import React, {useCallback, useContext, useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import Map, {Layer, Popup, Source} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import {ce_default_url} from "../../context/firebase-config";
import {authContext} from "../../context/authContext";
import './CompanyAsset.css'
import {Box, Button, Stack, TextField, Typography} from "@mui/material";

const CollectPortfolioForm = ({project, onClose, onSuccess, onError}) => {
    const user = useContext(authContext);
    const [query, setQuery] = useState('');
    const [assets, setAssets] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [hoverInfo, setHoverInfo] = useState(null);
    const [portfolioName, setPortfolioName] = useState(null);
    const navigate = useNavigate();
    const [viewState, setViewState] = useState({
        longitude: 12.82,
        latitude: 18.55,
        zoom: 2.23
    });

    useEffect(() => {
        if (!searchTerm) return;
        fetchCompanyAssetData(user, project, searchTerm, setAssets, setIsLoading);
    }, [project, searchTerm, user]);

    useEffect(() => {
        if (!assets) return;
        let pn = ''
        assets.features.map((feature, idx) => {
            if (idx === 0) {
                pn = feature.properties.company_name.replace(/\s/g, '_') + '.geojson'
            }
        })
        console.log(`portfolio name: ${pn}`)
        setPortfolioName(pn)
    }, [assets])

    const handleSearch = () => {
        setSearchTerm(query);
    };

    const handleHover = useCallback((event) => {
        const feature = event.features && event.features[0];
        if (feature) {
            setHoverInfo({
                lngLat: event.lngLat,
                properties: feature.properties
            });
        } else {
            setHoverInfo(null);
        }
    }, []);

    const companyAssetData = companyAssetDataParser(viewState, setViewState, handleHover, hoverInfo, setHoverInfo, assets);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "10px",
            top: "10%",
        }}>
            <div style={{
                width: "15%",
                zIndex: 1,
                textAlign: "center",
                background: "transparent",
            }}>
                <Box mx="auto" p={4}>
                    <Stack direction="column" spacing={1}>
                        <TextField
                            className="custom-textfield"
                            label="Enter ticker or company name"
                            variant="outlined"
                            fullWidth
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            InputLabelProps={{className: 'custom-label'}}
                        />
                        <TextField
                            className="custom-textfield"
                            label="Enter asset type"
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{className: 'custom-label'}}
                        />
                        <Button variant="contained" style={{height: 30}} onClick={handleSearch}>
                            Search for Assets
                        </Button>
                    </Stack>
                    {isLoading && (<Typography variant="h5" className="gray-text">Loading...</Typography>)}
                </Box>
            </div>
            <div style={{
                alignItems: "center",
                width: "80%",
                height: "60%",
                zIndex: 1,
                background: "transparent",
            }}>
                {!isLoading && assets && (companyAssetData)}
                {!!portfolioName && (
                    <Box mx="auto" p={2} style={{width: "20%"}}>
                        <Stack direction="column" spacing={1} style={{alignItems: "center"}}>
                            <p></p>
                            <p></p>
                            <Typography variant="h5" className="gray-text">{portfolioName}</Typography>
                            <Button variant="contained" style={{height: 30}} onClick={() => navigate('/portfolios')}>
                                Confirm Assets
                            </Button>
                        </Stack>
                    </Box>
                )}
            </div>
        </div>
    );
};

const companyAssetDataParser = (viewState, setViewState, handleHover, hoverInfo, setHoverInfo, assets) => {
    if (!assets) return (<></>)

    const accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
    const pointLayer = {
        id: "point-layer",
        type: "circle",
        paint: {
            'circle-radius': 5,
            'circle-color': '#EE4B2B'
        }
    };

    return (
        <Map
            {...viewState}
            onMove={(evt) => setViewState(evt.viewState)}
            // style={{width: "100vw", height: "100vh"}}
            style={{width: "80vw", height: "60vh"}}
            mapStyle={"mapbox://styles/mapbox/dark-v9"}
            mapboxAccessToken={accessToken}
            interactiveLayerIds={["point-layer"]}
            onMouseMove={handleHover}
            onMouseLeave={() => setHoverInfo(null)}
        >
            <Source id="barrick" type="geojson" data={assets}>
                <Layer {...pointLayer} />
            </Source>

            {hoverInfo && (
                <Popup
                    longitude={hoverInfo.lngLat.lng}
                    latitude={hoverInfo.lngLat.lat}
                    closeButton={false}
                    closeOnClick={false}
                    anchor="top"
                >
                    <div>
                        <ul>
                            <li><strong>Name: {hoverInfo.properties.asset_name}</strong></li>
                            <li><strong>Type: {hoverInfo.properties.asset_type}</strong></li>
                            <li><strong>State: {hoverInfo.properties.region_state}</strong></li>
                            <li><strong>Country: {hoverInfo.properties.country}</strong></li>
                        </ul>
                    </div>
                </Popup>
            )}
        </Map>
    );
}

const fetchCompanyAssetData = (user, project, query, dataSetter, setIsLoading) => {
    setIsLoading(true);
    user && user.getIdTokenResult()
        .then((token) => {
            if (!!token.claims.api_key) {
                fetch(`${ce_default_url}/api/financial/company/assets?q=${query}`, {
                    method: 'GET',
                    headers: {
                        'X-SustGlobal-APIKey': token.claims.api_key,
                        'X-SustGlobal-Project': `${project}`,
                    }
                })
                    .then(r => r.json())
                    .then(r => dataSetter(r))
            } else {
                console.error('api key not available for user')
            }
        })
        .catch((error) => {
            console.error(`error while fetching from API: ${error}`)
        })
        .finally(() => setIsLoading(false))
}

export default CollectPortfolioForm;
